export enum Applications {
  FIRST_PARTY_FNOL = 'FirstPartyFnol',
  THIRD_PARTY_FNOL = 'ThirdPartyFnol',
  MYACCOUNT_ADMIN = 'MyAccountAdmin',
  DRP_SEARCH = 'DrpSearch'
}
